export default __webpack_public_path__ + "static/media/Diviner's Hood of Supreme Decree.aaa8b771.jpg";